import styled from "styled-components";

export const StyledLayout = styled.section`
  display: grid;
  grid-template-columns: 20% auto;
`;

export const StyledLeftLayout = styled.div`
  min-height: 100vh;
`;

export const StyledMainSection = styled.main`
  position: relative;
  background-color: lightgray;
  padding: 40px 20px;
`;
